import { Col, Row } from "antd";
import { Power3, TweenMax } from "gsap";
import { useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useLocation } from "react-router";
import { AnimationTime, EMAIL, GITHUB, LINKEDIN, PHONE } from "../App.constant";
import AtSVG from "../assets/images/at.svg";
import GithubSVG from "../assets/images/github.svg";
import LinkedinSVG from "../assets/images/linkedin.svg";
import TelephoneSVG from "../assets/images/telephone.svg";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";
import Message from "./Message";

const Contact = (props) => {
  const location = useLocation();

  useEffect(() => {
    props?.masterStore?.setSelectedBar(location?.pathname);
  }, [location?.pathname]);

  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const [state, setState] = useState({
    copied: false,
  });
  const handlePhoneClick = () => {
    setState({ ...state, copied: true });
    setTimeout(() => {
      setState({ ...state, copied: false });
    }, 2000);
  };

  const handleClose = () => {
    setState({ ...state, copied: false });
  };

  const logoRef = useRef(null);
  const textRef = useRef(null);
  const heroRef = useRef(null);

  useEffect(() => {
    TweenMax.to(logoRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
    }).play();

    TweenMax.to(textRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
      delay: 0.2,
    }).play();

    TweenMax.to(heroRef.current, AnimationTime, {
      opacity: 1,
      y: -20,
      ease: Power3.easeInOut,
      delay: 0.2,
    }).play();
  }, []);

  useEffect(() => {
    if (window) {
      props?.masterStore?.setSelectedBar(location?.pathname);
    }
  }, [location?.pathname]);
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
          paddingTop: "2%",
          marginBottom: "10%",
          marginTop: isTabletOrMobileDevice ? 100 : 0,
        }}
      >
        <center>
          <Row align="middle" ref={logoRef}>
            <Col span={24}>
              <div
                style={{
                  color: "#FFFFFF",
                  fontSize: 30,
                  fontWeight: "bold",
                  textAlign: "center",
                  fontFamily: "'Montserrat', sans-serif",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  fontSize: 14,
                  color: "#33CC99"
                }}
              >
                Say Hi
              </div>
            </Col>
          </Row>
          <Row align="middle" ref={textRef}>
            <Col span={24}>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: "200",
                  textAlign: "center",
                   fontFamily: "'Montserrat', sans-serif",
                  backgroundColor: "transparent",
                  color: "#FFF",
                }}
              >
                I'll be happy to answer all your questions or <br /> inquiries,
                feel free to say Hello.
              </div>
            </Col>
          </Row>
          <Row align="middle" ref={heroRef}>
            <Col span={24}>
              <div
                style={{
                  width: isTabletOrMobileDevice ? "90%" : "50%",
                  padding: 50,
                  borderRadius: 20,
                  marginTop: 50,
                  marginBottom: 50,
                }}
                className="glass-dark"
              >
                <Row align="middle">
                  <Col span={24}>
                    <center>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`mailto:${EMAIL}`}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 10,
                          borderRadius: 10,
                          backgroundColor: "rgba(0,0,0,0.2)",
                        }}
                      >
                        <img
                          src={AtSVG}
                          style={{
                            width: isTabletOrMobileDevice ? 10 : 20,
                            height: isTabletOrMobileDevice ? 10 : 20,
                          }}
                        ></img>
                        <span
                          style={{
                            marginLeft: 10,
                            color: "#FFFFFF",
                            fontSize: isTabletOrMobileDevice ? 14 : 16,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          Reach me via Email
                        </span>
                      </a>
                    </center>
                  </Col>
                </Row>
                <Row align="middle" style={{ marginTop: 30 }}>
                  <Col span={24}>
                    <center>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={GITHUB}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 10,
                          borderRadius: 10,
                          backgroundColor: "rgba(0,0,0,0.2)",
                        }}
                      >
                        <img
                          src={GithubSVG}
                          style={{
                            width: isTabletOrMobileDevice ? 10 : 20,
                            height: isTabletOrMobileDevice ? 10 : 20,
                          }}
                        ></img>
                        <span
                          style={{
                            marginLeft: 10,
                            color: "#FFFFFF",
                            fontSize: isTabletOrMobileDevice ? 14 : 16,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          Reach me via Github
                        </span>
                      </a>
                    </center>
                  </Col>
                </Row>
                <Row align="middle" style={{ marginTop: 30 }}>
                  <Col span={24}>
                    <center>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={LINKEDIN}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 10,
                          borderRadius: 10,
                          backgroundColor: "rgba(0,0,0,0.2)",
                        }}
                      >
                        <img
                          src={LinkedinSVG}
                          style={{
                            width: isTabletOrMobileDevice ? 10 : 20,
                            height: isTabletOrMobileDevice ? 10 : 20,
                          }}
                        ></img>
                        <span
                          style={{
                            marginLeft: 10,
                            color: "#FFFFFF",
                            fontSize: isTabletOrMobileDevice ? 14 : 16,
                            fontFamily: "'Montserrat', sans-serif",
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          Reach me via LinkedIn
                        </span>
                      </a>
                    </center>
                  </Col>
                </Row>
                <Row align="middle" style={{ marginTop: 30 }}>
                  <Col span={24}>
                    <center>
                      <CopyToClipboard text={PHONE} onCopy={handlePhoneClick}>
                        <span
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 10,
                            borderRadius: 10,
                            backgroundColor: "rgba(0,0,0,0.2)",
                            cursor: "copy",
                          }}
                        >
                          <img
                            src={TelephoneSVG}
                            style={{
                              width: isTabletOrMobileDevice ? 10 : 20,
                              height: isTabletOrMobileDevice ? 10 : 20,
                            }}
                          ></img>
                          <span
                            style={{
                              marginLeft: 10,
                              color: "#FFFFFF",
                              fontSize: isTabletOrMobileDevice ? 14 : 16,
                              fontFamily: "'Montserrat', sans-serif",
                              width: "100%",
                              overflow: "hidden",
                            }}
                          >
                            Call {PHONE}
                          </span>
                        </span>
                      </CopyToClipboard>
                    </center>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </center>
      </div>
      <Message
        title="Copied to Clipboard"
        type="success"
        description="Paste in your phone book"
        isActive={state.copied}
        onClose={handleClose}
      />
    </>
  );
};

export default stateWrapper(Contact);
